import { ReactComponent as TrashIcon } from 'assets/icons/trash2.svg';

import LineMenu from './Menu/BorderColorPicker';
import FillColorPicker from './Menu/FillColorPicker';
import SetBorder from './Menu/SetBorder';
import style from './SelectedItemMenu.module.css';

interface Props {
  onChange: (val) => void;
  menuPosition: any;
  data: any;
}

const ShowSelection = ({ menuPosition, onChange, data }: Props) => {
  return (
    <div
      className={style.container}
      style={{
        left: `${menuPosition.x}px`,
        top: `${menuPosition.y}px`,
      }}
    >
      {['rect', 'ellipse', 'arrow'].indexOf(data.tool) > -1 && (
        <FillColorPicker fill={data.fill ?? 'transparent'} onChange={onChange} />
      )}

      {['line', 'pen', 'rect', 'ellipse', 'arrow', 'marker'].indexOf(data.tool) > -1 && (
        <LineMenu color={data.color} onChange={onChange} />
      )}
      {['line', 'rect', 'ellipse', 'marker', 'arrow'].indexOf(data.tool) > -1 && (
        <SetBorder value={data.strokeWidth} onChange={onChange} />
      )}
      <div className={style.inputContainer}>
        <span className={style.button} onClick={() => onChange('delete')}>
          <TrashIcon />
        </span>
      </div>
    </div>
  );
};

export default ShowSelection;
